import { configureStore } from "@reduxjs/toolkit";
import AllDoctorApi from "../Slice/Slice"

export default configureStore({
    reducer: {
        AllDoctorApi: AllDoctorApi
    }
})